var exports = {
  "hJ": "CharacterCounter.module__counter___ZkkwUX",
  "$s": "CharacterCounter.module__counterButton___ZkkwUX" + " " + "CharacterCounter.module__counter___ZkkwUX",
  "N1": "CharacterCounter.module__counterSpan___ZkkwUX" + " " + "CharacterCounter.module__counter___ZkkwUX",
  "jL": "CharacterCounter.module__textDanger___ZkkwUX",
  "gF": "CharacterCounter.module__textTertiary___ZkkwUX",
};

module.exports = exports;
